import React from 'react';
import { useNavigate } from 'react-router-dom';
import './css/UsersList.css';

const UsersList = ({ data, getMoreData, hasMore }) => {
  const navigate = useNavigate();

  const handleOnUserClicked = (user) => {
    navigate(`/manage-licences/${user.id}`, { state: { user } });
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('pl-PL');
  };

  if (!data || data.length === 0) {
    return (
      <div className="empty-placeholder">
        No users or licenses found on the list.
      </div>
    );
  }

  return (
    <div className="users-list-wrapper">
      <table className="users-table">
        <thead>
          <tr>
            <th>Company</th>
            <th>Company address</th>
            <th>Organization number</th>
            <th>E-mail</th>
            <th>Created date</th>
            <th>Active license</th>
            <th>Account Status</th>
          </tr>
        </thead>
        <tbody>
          {data.map((user) => (
            <tr
              key={`user-${user.id}`}
              onClick={() => handleOnUserClicked(user)}
              className={user.hasActiveLicense ? 'row-active-license' : ''}
            >
              <td className="company-name">{user.companyName || '-'}</td>
              <td>{user.companyAddress || '-'}</td>
              <td>{user.organizationNumber || '-'}</td>
              <td>{user.email || '-'}</td>
              <td>{formatDate(user.createdDate)}</td>
              <td>
                {user.hasActiveLicense ? (
                  <span className="badge badge-green">Yes</span>
                ) : (
                  <span className="badge badge-red">No</span>
                )}
              </td>
              <td>
                {user.isActive ? (
                  <span className="badge badge-green">Active</span>
                ) : (
                  <span className="badge badge-red">Blocked</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {hasMore && (
        <div className="load-more-container">
          <button className="btn-load-more" onClick={getMoreData}>Load more</button>
        </div>
      )}
    </div>
  );
};

export default UsersList;
